export type SocialAccountCap =
  | { state: 'unlimited' }
  | { state: 'disabled' }
  | { state: 'capped'; max: number };

export function resolveSocialAccountCap(value: number | undefined | null): SocialAccountCap {
  if (value === undefined || value === null || value === -1) {
    return { state: 'unlimited' };
  }
  if (value === 0) {
    return { state: 'disabled' };
  }
  return { state: 'capped', max: value };
}

export function normalizeSocialCapValue(raw: unknown): number | undefined {
  if (raw === undefined || raw === null) return undefined;
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : undefined;
  if (typeof raw === 'boolean') return raw ? -1 : 0;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (trimmed === '') return undefined;
    const n = Number(trimmed);
    return Number.isFinite(n) ? n : undefined;
  }
  if (typeof raw === 'object' && 'limit' in (raw as Record<string, unknown>)) {
    return normalizeSocialCapValue((raw as { limit: unknown }).limit);
  }
  return undefined;
}

export interface SocialAccountSlots {
  cap: SocialAccountCap;
  used: number;
  disabled: boolean;
  atCap: boolean;
  canConnect: boolean;
  blockedReason: string | null;
}

export function resolveSocialAccountSlots({
  value,
  used,
  platformName,
}: {
  value: number | undefined | null;
  used: number;
  platformName: string;
}): SocialAccountSlots {
  const cap = resolveSocialAccountCap(value);
  const safeUsed = Number.isFinite(used) && used > 0 ? Math.floor(used) : 0;
  const disabled = cap.state === 'disabled';
  const atCap = cap.state === 'capped' && safeUsed >= cap.max;

  return {
    cap,
    used: safeUsed,
    disabled,
    atCap,
    canConnect: !disabled && !atCap,
    blockedReason: disabled ? `${platformName} is not available on your current plan.` : null,
  };
}
